import React, { useEffect } from "react"
import { Spacer } from "../atoms/Atoms"
import L10n from "lib/carrot-l10n"
import { IlloUnderwaterPlants } from "../atoms/Illustrations"
import { Body } from "../atoms/Bodies"
import { ButtonPrimary } from "../atoms/buttons/ButtonPrimary"
import { MasterLayout } from "../atoms/layouts/MasterLayout"
import { H2 } from "@carrotfertility/carotene"
import { getHeap } from "utils/heap"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const PageNotFound = () => {
  useEffect(() => {
    getHeap().track("PageNotFound", { EventName: "User saw page not found screen" })
  }, [])

  return (
    <MasterLayout header={null}>
      <div className="flex-auto flex flex-column justify-center items-center w-100 vh-100-ns">
        <div className={`flex-none br3 bg-pampas animate-all mw6-ns  pv4`}>
          <div className="tc pa4">
            <IlloUnderwaterPlants />
            <Spacer height={1} />
            <H2>{l`client.pageNotFound`}</H2>
            <Spacer height={0.25} />
            <Body color="black-80">{l`client.couldntFindPage`}</Body>
            <Spacer height={1} />
            <ButtonPrimary to="/">{l`client.returnHome`}</ButtonPrimary>
          </div>
        </div>
      </div>
    </MasterLayout>
  )
}

export { PageNotFound }
